import Parent from '@/api/home/parent'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  profile: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  RECEIVE_PROFILES(state, data) {
    state.profile = data
  }
}

export const actions = {
  fetchProfile(context = {}) {
    return Parent.getProfile().then(response => {
      context.commit('RECEIVE_PROFILES', response.data)
      return Promise.resolve(response)
    })
  },

  uploadPhoto(context, data) {
    return Parent.uploadPhoto(data)
  },
  changePwd(context, data) {
    return Parent.changePassword(data)
  }
}
